export class PaybleComponentReq{
    fromDate : any
    toDate : any
    vendorId : number
    type : string
    division : any
    unit?: number;

    constructor(fromDate : any,toDate : any,vendorId : number,type : string,division : any,unit?: number){
    this.fromDate = fromDate
    this.toDate = toDate
    this.vendorId = vendorId 
    this.type = type 
    this.division = division 
    this.unit = unit
    }
}